<template>
  <div class="card" :body-style="{ padding: '0'}">
    <div style="padding: 5px 5px 0 5px;">
      <div
        class="image-button"
        >
        <img
          ref="image"
          v-lazy="image"
          class="card-image"
          :title="imageTitle()"
          >
      </div>
      {{evaluatorData ? `Success: ${evaluatorData.success} pred_prob: ${evaluatorData.pred_prob}` : 'Not Evaluated'}}
    </div>
    <div
      style="display: flex; justify-content: center; align-content: center; width: 100%; margin-top: .5rem;"
      >
      <owal-button
        type="none"
        @click="handleClick"
        :title="this.buttonText"
        :destructive="true"
        />
    </div>
  </div>
</template>

<script>
import OwalButton from '@/libraries/owal-ui/buttons/OwalButton'
import moment from 'moment'

export default {
  name: 'ConfirmationCard',
  props: {
    buttonText: {
      type: String,
    },
    image: {
      type: String,
    },
    buttonType: {
      type: String,
    },
    tagged: {
      type: Object,
    },
    evaluatorData: {
      type: Object,
    },
  },
  methods: {
    handleClick: function () {
      this.$emit('click')
    },
    imageTitle: function () {
      const date = moment.utc(this.tagged.at)
      const taggedBy = this.tagged.by || 'Unknown'
      const taggedAt = date.isValid() ? date.local().format('MMMM Do, hh:mm a') : 'Unknown'
      const title = 'By: ' + taggedBy + '\n' + 'At: ' + taggedAt
      return title
    },
  },
  components: {
    OwalButton,
  },
}
</script>

<style scoped>
.card {
  width: 200px;
  height: 205px;
  display: inline-flex;
  flex-direction: column;
}

.card-image {
  width: 100%;
  height: 144px;
  object-fit: cover;
  display: block;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  border-radius: 4px;
}

.image-button {
  padding: 0;
  border-radius: 4px;
}

</style>
